import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { LeadDataResponse, LeadQueryParams } from '../types';
import { LEAD_LIST_QUERY_KEY } from './constants';

const useGetLeadsListQuery = (
    payload: LeadQueryParams,
    options: { enabled?: boolean; heroOrgIds?: string[] } = {}
) => {
    const req = useRequest();
    const { heroOrgIds } = options;

    // [HWM-23014] See useGetLeadsList: an array of org ids becomes repeated
    // ?hero_organization_id= keys, which is how a search spans every accessible provider.
    const action = useCallback(() => {
        return req<LeadDataResponse>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/leads/`,
            method: 'POST',
            body: JSON.stringify(payload),
            ...(heroOrgIds?.length && { query: { hero_organization_id: heroOrgIds } })
        });
    }, [req, payload, heroOrgIds]);

    return useQuery({
        queryFn: action,
        // Org ids belong in the key: the same search under a different provider set is a
        // different result, and serving one from the other's cache is the HWM-23014 leak.
        queryKey: [LEAD_LIST_QUERY_KEY, payload, heroOrgIds ?? null],
        enabled: options.enabled !== false
    });
};

export default useGetLeadsListQuery;
